import { render, staticRenderFns } from "./productinfo.vue?vue&type=template&id=fd621154&"
import script from "./productinfo.vue?vue&type=script&lang=js&"
export * from "./productinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports